import React from "react";

const GroupSexRoomFergusonOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="511.216"
      height="403.393"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 511.216 403.393"
      xmlSpace="preserve"
      className='clickable object-glow'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        transform="translate(-34.831 -162.392)"
      >
        <path
          d="M505 233.339l-19.897-5.855s-1.386-.316-1.775-1.171.219-2.25.219-2.25l10.79-34.985s.685-1.607 1.731-2.171c1.046-.564 2.455-.085 2.455-.085l32.871 9.801s1.35.433 1.838 1.529c.489 1.096.116 2.855.116 2.855l-10.209 30.301"
          opacity="1"
        ></path>
        <path
          d="M508.084 225.044l-4.784-.236s-1.63-.326-2.597-1.492c-.967-1.165-1.27-3.17-1.27-3.17l-.082-12.044s.777-2.041 2.041-3.165c1.265-1.125 3.019-1.334 3.019-1.334l11.24-.182s1.899.816 2.899 2.44 1.101 4.056 1.101 4.056l.35 10.988s-.405 2.944-1.79 3.849c-1.385.906-3.359 1.001-3.359 1.001"
          opacity="1"
        ></path>
        <path
          d="M508.827 210.948s-1.745-.394-1.148 5.738c.598 6.132 1.518 11.046 3.108 16.449 1.59 5.403 3.252 5.164 3.252 5.164s1.482-.418 1.052-6.025c-.431-5.606-1.028-10.328-2.774-16.401-1.745-6.072-3.49-4.925-3.49-4.925z"
          opacity="1"
        ></path>
        <path
          d="M508.409 229.878c-.038-.253-1.615 2.131-1.81 2.395-1.147 1.555-1.838 4.801-1.867 6.695-.109 7.11.525 16.138 6.824 20.785"
          opacity="1"
        ></path>
        <path
          d="M511.612 235.707c-.636.448-.986 3.411-1.025 4.245-.156 3.265-.899 10.306 2.261 12.637"
          opacity="1"
        ></path>
        <path
          d="M516.579 235.159c.219 1.453 1.335 3.142 1.802 4.576 1.311 4.023.827 8.591-.403 12.383"
          opacity="1"
        ></path>
        <path
          d="M516.533 228.5c1.088.803 2.469.987 3.54 2.041 2.927 2.88 4.373 15.249 3.982 19.346-.21 2.198.829 7.773-1.325 9.29"
          opacity="1"
        ></path>
        <path
          d="M516.596 252.726c-2.471-2.137-3.083 4.65-3.058 5.346.271 7.353 1.704 13.721 4.402 20.553.589 1.492 1.859 5.562 3.971 5.584 2.156.023.582-7.104.474-8.277-.637-6.869.12-18.094-5.789-23.206z"
          opacity="1"
        ></path>
        <path
          d="M523.148 295.715c-.235-.775-.588 1.963-.626 2.732-.1 2.024-.298 4.393-.652 6.407-1.047 5.962-.915 13.496-.02 19.507.254 1.707.309 5.709 2.819 5.833 2.671.132 4.361-4.562 4.647-6.543.344-2.376.231-4.686.271-7.039.096-5.522 1.788-11.644.139-17.173-.533-1.787-1.338-5.302-3.692-5.531-2.015-.196-2.729 2.324-2.886 1.807z"
          opacity="1"
        ></path>
        <path
          d="M523.893 349.005c-1.801-.447-3.197 4.845-3.324 6.288-.561 6.37-1.898 13.015-.877 19.463.292 1.842.713 5.979 3.264 6.204 3.281.289 3.959-6.113 4.217-8.23.629-5.169 3.664-20.753-.938-24.096-.791-.575-1.604.554-2.342.371z"
          opacity="1"
        ></path>
        <path
          d="M521.799 401.308c-.945-.435-1.814 6.751-1.995 8.237-.451 3.702-1.804 19.519 4.091 19.756 2.973.12 3.245-8.063 3.47-9.911.446-3.663.637-17.048-2.593-19.394-1.427-1.037-2.113 1.707-2.973 1.312z"
          opacity="1"
        ></path>
        <path
          d="M521.748 446.247c-2.214.226-1.998 3.249-2.607 4.899-1.819 4.929-1.858 10.478-.888 15.61.252 1.333 1.44 5.715 3.353 5.735 2.599.028 3.405-3.288 3.973-5.288 1.055-3.714 2.136-21.565-3.831-20.956z"
          opacity="1"
        ></path>
        <path
          d="M521.357 490.555c-1.609-.5-2.454 11.746 1.161 13.522 2.949 1.449 4.33-5.081 4.292-6.832-.045-2.053-.54-6.769-2.982-7.463-.884-.251-1.484 1.08-2.471.773z"
          opacity="1"
        ></path>
        <path
          d="M510.592 259.703c-2.326.408-3.205 6.17-3.254 8.228-.206 8.697.9 18.417 5.577 25.976 1.464 2.364 2.532 4.78 4.193 7.024.521.704 2.629 2.764 2.601 2.606"
          opacity="1"
        ></path>
        <path
          d="M513.844 268.934c-1.185.208-.942 4.381-.914 5.265.178 5.612 1.093 10.861 3.129 16.093.638 1.64 2.134 3.185 3.147 4.553.288.389 2.042 1.859 1.565 1.359"
          opacity="1"
        ></path>
        <path
          d="M522.962 273.767c.377-.279 2.682 4.53 3.273 5.858 1.005 2.259 4.229 11.921 1.704 13.791"
          opacity="1"
        ></path>
        <path
          d="M522.149 259.82c1.164.174 5.69 7.693 6.281 9.619 3.525 11.476 6.095 16.85 2.574 28.646"
          opacity="1"
        ></path>
        <path
          d="M520.185 322.459c-1.992-.545-3.956 3.127-4.777 4.712-3.246 6.263-1.267 13.374-1.059 19.99.064 2.05 1.447 4.661 2.671 6.237.413.532 2.345 2.605 1.966 1.94"
          opacity="1"
        ></path>
        <path
          d="M521.655 329.462c-2.419 1.379-2.863 13.294-1.952 15.881.454 1.292 1.681 2.78 1.935 4.052"
          opacity="1"
        ></path>
        <path
          d="M529.091 328.658c.21 1.056 1.34 2.299 1.733 3.415 2.154 6.121.01 11.334-1.519 16.924"
          opacity="1"
        ></path>
        <path
          d="M531.312 319.793c-.1.02 2.493 3.257 2.86 3.792 1.477 2.151 2.56 5.326 2.785 7.944.577 6.7 2.716 18.586-2.262 24.141-1.115 1.244-2.732 1.787-3.966 2.745"
          opacity="1"
        ></path>
        <path
          d="M518.416 374.371c-5.605 7.442-7.735 14.264-6.958 23.836.245 3.006 1.952 5.651 3.265 8.29.332.667 2.995 2.991 2.995 2.726"
          opacity="1"
        ></path>
        <path
          d="M520.933 381.472c-.852-.002-1.057 2.424-1.35 3.092-1.429 3.246-2.628 8.776-1.432 12.187.366 1.046 2.535 5.326 2.428 4.569"
          opacity="1"
        ></path>
        <path
          d="M526.908 379.359c-.275.137.454 1.226.622 1.564.512 1.031.649 2.039.712 3.159.235 4.146.216 11.714-2.376 15.155"
          opacity="1"
        ></path>
        <path
          d="M528.482 374.205c8.943 6.736 7.893 19.937 3.221 29.233-.674 1.339-1.869 1.804-2.695 2.901"
          opacity="1"
        ></path>
        <path
          d="M518.54 419.977c-2.245-.754-4.664 2.936-5.574 4.646-2.735 5.14-3.826 15.483-1.794 21.033.576 1.575 1.797 4.095 3.365 4.883.41.206 2.171 1.945 2.122 1.599"
          opacity="1"
        ></path>
        <path
          d="M520.369 427.264c-2.869 1.427-3.584 9.526-2.59 12.529.432 1.305.588 2.594 1.211 3.847.15.301 1.302 1.833.967 1.159"
          opacity="1"
        ></path>
        <path
          d="M525.584 429.432c-.298.887 1.964 4.169 1.895 5.693-.097 2.13.38 4.473-.17 6.563-.351 1.334-1.57 3.616-1.573 4.842"
          opacity="1"
        ></path>
        <path
          d="M528.348 423.061c-.007.003.83.372 1.156.596.677.466 1.207.962 1.778 1.535 1.543 1.55 2.227 4.7 2.58 6.758.865 5.033-.006 12.867-2.318 17.468-.669 1.33-2.611 2.808-3.009 3.995"
          opacity="1"
        ></path>
        <path
          d="M517.099 463.576c-6.582 4.053-6.727 19.38-5.701 26.308.539 3.636 7.019 8.813 6.647 7.224"
          opacity="1"
        ></path>
        <path
          d="M519.118 471.614c-.466.042-1.361 2.546-1.534 3.062-1.021 3.039-1.825 8.804-.055 11.677.333.541 2.892 4.577 2.962 4.282"
          opacity="1"
        ></path>
        <path
          d="M524.768 471.799c-.69.061.829 1.129 1.091 1.771.493 1.209.976 2.582 1.091 3.887.221 2.492.603 5.516.021 7.967-.224.942-1.04 2.673-.957 3.602"
          opacity="1"
        ></path>
        <path
          d="M527.55 464.549c1.852-.164 4.431 5.688 5.076 7.052 2.026 4.289 2.997 23.515-4.18 24.15"
          opacity="1"
        ></path>
        <path
          d="M519.293 501.87l-7.936.742s-1.981-.068-3.556 1.292c-1.575 1.361-2.745 4.151-2.745 4.151l-3.276 42.832s-.333 3.848 1.016 6.207c1.348 2.36 4.377 3.231 4.377 3.231l28.667 3.46s4.421-.278 6.452-2.469c2.032-2.192 1.676-6.297 1.676-6.297l-.069-41.794s-1.032-4.938-2.792-7.78c-1.76-2.842-4.247-3.588-4.247-3.588l-8.789-.826"
          opacity="1"
        ></path>
        <path
          d="M523.503 513.774l-5.386-.656s-2.353-.269-3.417.845c-1.064 1.114-.839 3.61-.839 3.61l-1.195 25.576s.079 2.782 1.437 3.941c1.358 1.159 3.995.695 3.995.695l12.596.67s2.185-.119 3.108-1.432.584-3.822.584-3.822l.185-24.757s.43-2.567-.624-3.763c-1.053-1.197-3.591-1.023-3.591-1.023z"
          opacity="1"
        ></path>
        <path
          d="M55.551 213.046l-15.076-31.237s-1.415-2.143-1.007-3.729c.408-1.587 2.638-2.618 2.638-2.618l25.157-9.821s2.547-1.506 4.174-1.188c1.627.317 2.334 2.459 2.334 2.459l13.373 30.492s1.407 2.73 1.276 4.557c-.131 1.827-1.8 2.751-1.8 2.751l-20.712 8.41"
          opacity="1"
        ></path>
        <path
          d="M61.166 201.111c-2.255.511-3.563-3.607-3.883-5.017-.782-3.45 1.659-13.967 6.178-14.082 1.144-.029 2.612-.157 3.744.121 4.92 1.208 8.923 16.96 2.171 18.49"
          opacity="1"
        ></path>
        <path
          d="M63.937 196.335c-1.345.423-2.245 4.108-2.79 5.485-2.016 5.102-4.484 12.323-3.7 17.922.186 1.331.69 5.137 2.33 5.583 1.325.361 3.003-4.276 3.4-5.28 2.233-5.65 3.17-11.584 3.913-17.55.192-1.535-1.33-6.733-3.153-6.16z"
          opacity="1"
        ></path>
        <path
          d="M53.292 246.691c-.474-.75-.75 2.687-.83 3.191-.39 2.504-.573 5.077-.966 7.592-.662 4.231-4.353 20.965 1.406 22.533 3.545.965 5.753-14.825 5.908-17.086.325-4.744 1.885-12.457-1.404-16.484-.381-.467-1.924-1.707-2.58-1.488-.66.221-1.258 2.18-1.534 1.742z"
          opacity="1"
        ></path>
        <path
          d="M55.895 449.972c-6.421 1.102-5.615 17.85 1.254 17.305 2.293-.182 5.712-18.5-1.254-17.305z"
          opacity="1"
        ></path>
        <path
          d="M51.473 301.98c.306.292-1.254.315-1.795.715-1.36 1.005-2.074 2.399-2.489 4.01-1.69 6.565-2.509 15.376-.377 21.923.586 1.802 1.012 5.85 3.367 6.456 1.83.472 3.31-5.188 3.512-6.352 1.13-6.496 3.23-14.787 2.331-21.406-.226-1.671-1.142-4.041-2.537-5.052-.53-.384-2.958-1.197-2.012-.294z"
          opacity="1"
        ></path>
        <path
          d="M52.938 356.47c.216-.393-1.851 1.113-1.967 1.273-.85 1.173-1.581 3.291-1.376 4.801.708 5.219-.868 11.048 1.118 16.116.596 1.523 1.233 4.666 3.38 4.443 2.126-.221 2.008-3.494 2.273-5.018.915-5.261 1.054-12 .344-17.226-.18-1.329-1.042-3.293-2.152-4.098-.756-.547-1.982.365-1.62-.291z"
          opacity="1"
        ></path>
        <path
          d="M55.621 401.757c-2.278-1.435-3.773 4.277-3.902 5.483-.653 6.117-.539 13.149.692 19.164.25 1.224 2.145 5.21 3.529 5.084 3.463-.317 3.644-5.831 3.845-8.544.253-3.401 2.084-16.976-.128-19.717-1.832-2.269-3.269-.987-4.036-1.47z"
          opacity="1"
        ></path>
        <path
          d="M56.145 215.273c-2.556.654-4.883 4.439-6.012 6.768-3.249 6.7-5.81 14.345-5.662 21.821.05 2.558.797 5.916 2.219 8.038.467.697.976 1.698 1.653 2.222.224.174 1.272.561 1.044.466"
          opacity="1"
        ></path>
        <path
          d="M56.945 223.993c-3.38 2.932-3.94 9.337-4.893 13.75-.389 1.798-.635 5.003.211 6.672.1.195.205 1.011.432.814"
          opacity="1"
        ></path>
        <path
          d="M62.515 224.83c-.305.078.511.883.567.97.49.761.539 1.655.651 2.543.363 2.847.456 5.64.035 8.47-.28 1.884-1.205 4.821-2.172 6.454-.424.717-.73 1.528-1.088 2.224-.124.241-.94.815-.535.647"
          opacity="1"
        ></path>
        <path
          d="M65.744 218.647c-.237.061 2.276 1.628 3.034 2.761 1.168 1.743 1.72 5.534 1.76 7.614.155 7.825-.33 23.834-9.546 26.195"
          opacity="1"
        ></path>
        <path
          d="M48.175 270.264c-3.181-.226-4.96 3.26-5.988 5.742-2.516 6.074-3.208 13.813-2.18 20.355.335 2.134.82 5.266 2.295 6.967.389.448 2.868 2.645 2.724 2.298"
          opacity="1"
        ></path>
        <path
          d="M49.597 277.805c-1.358.348-1.379 3.171-1.532 4.345-.545 4.178-.443 8.363.088 12.538.19 1.49.453 2.888.82 4.317.124.488.864 2.13.758 1.718"
          opacity="1"
        ></path>
        <path
          d="M54.911 301.531c1.181-1.024 1.03-3.453 1.425-4.891 1.504-5.472 1.795-11.406.41-16.81"
          opacity="1"
        ></path>
        <path
          d="M58.174 310.036c2.393 2.758 5.249-5.243 5.484-6.219 1.658-6.894 2.904-15.157 1.428-22.17-.58-2.761-1.47-5.083-2.74-7.586-.404-.795-1.52-1.636-2.252-2.069-.264-.157-1.27-.593-1.09-.518"
          opacity="1"
        ></path>
        <path
          d="M45.037 327.932c-2.54-.905-4.628 8.705-4.854 9.912-1.183 6.298-1.218 15.782 2.852 21.243 1.138 1.525 3.045 2.449 4.173 3.624"
          opacity="1"
        ></path>
        <path
          d="M46.957 332.926c-.967.928-.554 4.865-.582 6.207-.095 4.644-.262 9.174 1.137 13.674.363 1.17 1.409 2.164 1.753 3.272"
          opacity="1"
        ></path>
        <path
          d="M54.579 355.834c1.763-4.952 3.142-17.27-1.124-21.714"
          opacity="1"
        ></path>
        <path
          d="M58.502 361.779c-.34.327 2.329-.353 2.899-.8 1.053-.827 1.517-3.087 1.757-4.363 1-5.325.878-11.669.095-17.037-.497-3.412-1.388-6.402-3.453-9.172-.86-1.154-1.671-1.355-2.685-2.178-.28-.226-1.347-.779-1.302-.633"
          opacity="1"
        ></path>
        <path
          d="M48.881 372.402c-1.986-.707-4.297 4.422-4.57 5.873-1.395 7.435-2.75 14.965-1.167 22.526.28 1.336 4.547 7.964 5.433 6.28"
          opacity="1"
        ></path>
        <path
          d="M50.744 380.227c-1.06 1.017-.693 3.763-.865 5.19-.5 4.148-1.43 11.724 1.865 15.156"
          opacity="1"
        ></path>
        <path
          d="M57.759 400.645c-.592.568.785-1.491.856-2.308.14-1.596-.143-3.163-.004-4.753.255-2.923.24-6.579-.363-9.462-.13-.623-1.13-3.078-.842-3.355"
          opacity="1"
        ></path>
        <path
          d="M62.012 405.282c.28.899 2.081-.846 2.402-1.215.917-1.056 1-4.381 1.027-5.743.108-5.289.487-10.831-.278-16.084-.38-2.611-1.242-5.313-2.73-7.488-.539-.789-1.514-1.381-2.287-1.867-.266-.167-1.207-.463-.953-.373"
          opacity="1"
        ></path>
        <path
          d="M50.2 421.991c-1.941-1.764-4.452 6.955-4.686 7.787-1.705 6.067-3.006 14.256-1.792 20.581.475 2.474 1.131 4.872 3.046 6.612.402.366 2.578 2.113 2.909.935"
          opacity="1"
        ></path>
        <path
          d="M52.818 450.596c-.244.269-.723-.459-.786-.544-.964-1.306-1.11-4.493-1.183-6.03-.164-3.43-.984-10.76 1.503-13.497"
          opacity="1"
        ></path>
        <path
          d="M59.133 449.758c3.258-3.585 1.876-14.573.32-18.587"
          opacity="1"
        ></path>
        <path
          d="M61.239 457.31c-.076.083 1.445-.275 1.888-.762 1.051-1.157 1.715-2.664 2.402-4.053 1.792-3.623 1.593-8.87 1.895-12.8.284-3.704-.078-8.566-1.647-12.004-.607-1.328-1.362-2.433-2.446-3.418-.354-.322-1.453-1.231-1.446-1.229"
          opacity="1"
        ></path>
        <path
          d="M50.444 463.687l-6.194-.17s-2.87.087-4.494 1.611c-1.623 1.525-2 4.487-2 4.487l-.925 43.978s.362 3.959 2.22 5.866c1.857 1.907 5.209 1.761 5.209 1.761l23.081.872s2.99-.519 5.051-2.443c2.062-1.924 3.196-5.253 3.196-5.253l1.131-40.747s-.332-3.868-1.756-5.957c-1.424-2.088-3.94-2.397-3.94-2.397l-10.367-1.318"
          opacity="1"
        ></path>
        <path
          d="M51.193 477.689s-2.097-.139-3.224.975c-1.128 1.113-1.285 3.478-1.285 3.478l.387 22.88s-.068 1.843 1.031 3.021c1.1 1.178 3.367 1.692 3.367 1.692l10.668-.57s2.455-.967 3.587-2.298c1.133-1.331.942-3.026.942-3.026l.127-20.768s-.556-2.26-1.734-3.652c-1.177-1.391-2.977-1.913-2.977-1.913z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default GroupSexRoomFergusonOutline;
